import { createRouter, createWebHistory } from 'vue-router'
import { safeInternalPath } from '../lib/paths'
import { useSession } from '../lib/session'
import Layout from '../components/Layout.vue'
import LoginPage from '../pages/Login.vue'
import OverviewPage from '../pages/Overview.vue'
import UsersPage from '../pages/Users.vue'
import UserDetailPage from '../pages/UserDetail.vue'
import AuditPage from '../pages/Audit.vue'
import CatalogPage from '../pages/Catalog.vue'
import CatalogDetailPage from '../pages/CatalogDetail.vue'
import NotFoundPage from '../pages/NotFound.vue'

export const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/login', name: 'login', component: LoginPage, meta: { public: true } },
    {
      path: '/',
      component: Layout,
      children: [
        { path: '', name: 'overview', component: OverviewPage },
        { path: 'users', name: 'users', component: UsersPage },
        { path: 'users/:id', name: 'user-detail', component: UserDetailPage },
        { path: 'audit', name: 'audit', component: AuditPage },
        { path: 'catalog', name: 'catalog', component: CatalogPage },
        { path: 'catalog/:id', name: 'catalog-detail', component: CatalogDetailPage },
        { path: ':pathMatch(.*)*', name: 'not-found', component: NotFoundPage },
      ],
    },
  ],
})

router.beforeEach((to) => {
  const { status } = useSession()
  const isPublic = to.meta.public === true

  if (isPublic) {
    if (status.value === 'authenticated') {
      return safeInternalPath(to.query.from)
    }
    return true
  }

  // checking 放行，Layout 等 me()
  if (status.value === 'anonymous') {
    return { path: '/login', query: { from: to.fullPath } }
  }

  return true
})
